// extracted by mini-css-extract-plugin
module.exports = {"launches__header":"Launches_launches__header__7hHx-","launches__latest":"Launches_launches__latest__5SmV0"};